module.exports = __webpack_public_path__ + "img/flicker_right.3dbf216a.gif";